import dayjs from "dayjs";

import { useTimezone } from "@web-app/api";
import { ConfirmModal } from "@web-app/components";
import { Order } from "@web-app/types";

export default function DateChangeModal({
  startDate,
  orderTimezone,
  onDateChangeConfirm,
  onDateChangeCancel,
}: {
  onDateChangeCancel: () => void;
  onDateChangeConfirm: () => void;
  orderTimezone: Order["timezone"];
  startDate: Date;
}) {
  const { getTimezoneValue } = useTimezone();

  return (
    <ConfirmModal
      isOpen={!!startDate}
      title="Change Date?"
      onClose={onDateChangeCancel}
      subtitle={
        <p>
          This order will move to{" "}
          <strong>
            {dayjs(startDate).format("MMMM DD, YYYY")}{" "}
            {getTimezoneValue(orderTimezone)}
          </strong>
          . To view it, please update your date filter to that day.
        </p>
      }
      actions={[
        {
          label: "Confirm",
          onClick: onDateChangeConfirm,
        },
        {
          label: "Cancel",
          onClick: onDateChangeCancel,
          plain: true,
        },
      ]}
    />
  );
}
